<template>
    <div v-if="getBanners.length > 1">
        <Carousel v-bind="carouselSettings" :autoplay="autoplay" :wrap-around="wrapAround" @panstart="handlePanStart" @panend="handlePanEnd">
            <Slide v-for="banner in getBanners" :key="banner.id">
                <div class="carousel__item relative " :dir="banner.direction" @mousedown="mouseDownHandler" @mouseup="mouseUpHandler(banner)">
                    <img alt="Vue logo" :srcset="getSrcset(banner)" class="h-full w-full -mb-2"/>
                    <div v-if="banner.title || banner.description" class="absolute inset-0"></div>
                    <div class="absolute bottom-5 w-full px-12 ltr:text-left rtl:text-right">
                        <h1 v-html="banner.title" class="text-3xl font-extrabold sm:text-5xl ltr:text-left rtl:text-right"></h1>
                        <p v-html="banner.description" class="mt-4 max-w-lg text-sm sm:text-xl/relaxed"></p>
                        <div v-html="banner.buttons" class="max-w-lg mt-8 flex gap-4 text-center"></div>
                    </div>
                </div>
            </Slide>
            <template #addons>
                <!-- <Pagination /> -->
                <Navigation />
            </template>
        </Carousel>
    </div>

    <div v-else>
        <div v-for="banner in getBanners" :key="banner.id" @click="handleBannerClick(banner)" class="cursor-pointer relative">
                <img alt="Vue logo" :srcset="getSrcset(banner)" class="h-full w-full -mb-2"/>
                <div v-if="banner.title || banner.description" class="absolute inset-0 from-white/75 sm:to-transparent bg-gradient-to-t ltr:sm:bg-gradient-to-r rtl:sm:bg-gradient-to-l"></div>
                <div class="absolute bottom-5 w-full px-12 ltr:text-left rtl:text-right">
                <h1 v-html="banner.title" class="text-3xl font-extrabold sm:text-5xl ltr:text-left rtl:text-right"></h1>
                <p v-html="banner.description" class="mt-4 max-w-lg text-sm sm:text-xl/relaxed"></p>
                <div v-html="banner.buttons" class="max-w-lg mt-8 flex gap-4 text-center"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { Carousel, Slide, Navigation } from 'vue3-carousel'
    import 'vue3-carousel/dist/carousel.css'
    
    export default({
        name: 'BannerCarousel',
        components: {
            Carousel,
            Slide,
            Navigation
        },
        data() {
            return {
                autoplay: 15000,
                wrapAround: true,
                carouselSettings: {
                    itemsToShow: 1,
                    snapAlign: 'center'
                }
            }
        },
        methods: {
            ...mapActions(['fetchBanners']),
          
            getSrcset(banner) {
                let src = `${process.env.VUE_APP_URL_SERVER}/api/banner/image/`;
                if(!banner.mobileImage){
                    return src + banner.desktopImage
                }else{
                    return `${src + banner.mobileImage} 880w, ${src + banner.desktopImage} 1920w`;
                }
            },
            mouseDownHandler() {
                this.isMouseDown = true;
            },
            mouseUpHandler(banner) {
                if (!this.isDragging && this.isMouseDown) {
                    this.isMouseDown = false;
                    this.handleBannerClick(banner);
                }
            },
            handleBannerClick(banner) {
                if (banner.linkUrl.startsWith(process.env.VUE_APP_URL)) {
                    const path = banner.linkUrl.slice(process.env.VUE_APP_URL.length);
                    this.$router.push(path);
                } else {
                    window.open(banner.linkUrl, banner.linkTarget || '_self');
                }
            },
            handlePanStart() {
                this.isDragging = true;
            },
            handlePanEnd() {
                this.isDragging = false;
            },
            parseButtons(buttonsString) {
                try {
                    const buttons = JSON.parse(buttonsString);
                    console.log(buttons)
                    return buttons;
                } catch (error) {
                    console.error('Erro ao analisar botões:', error);
                    return [];
                }
            }
        },
        computed: {
            ...mapGetters(['getBanners']),
          
        },
        mounted() {
            this.fetchBanners();
        }
    })
</script>

